import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { QuestionnaireDto } from '@api/models/questionnaire/QuestionnaireDto';
import { EntityState } from '@api/models/enums/EntityState';
import { questionnaireService } from '@api/services/services';

type State = BaseType<QuestionnaireDto>;

const initialState: State = {
  state: FetchState.None,
  data: {
    id: '',
    name: '',
    nameEn: '',
    state: EntityState.Active,
    note: '',
    trainings: [],
  },
};

export const questionnaireSlice = baseSlice({
  name: 'questionnaire',
  initialState,
});

export const selectQuestionnaireState = (state: RootState) => state.questionnaire.state;
export const selectQuestionnaire = (state: RootState) => state.questionnaire.data;
export const questionnaireActions = questionnaireSlice.actions;

export const getQuestionnaire = (questionnaireId: string) => (dispatch: AppDispatch) => {
  const handleGetData = () => {
    return questionnaireService.getById(questionnaireId);
  };

  getItem({
    dispatch,
    actions: questionnaireActions,
    getData: handleGetData,
  });
};
